import { defineMessages } from 'react-intl';

const trns = defineMessages({
  question1: {
    id: 'OEWNGc',
    defaultMessage:
      'Чи можна замовити з доставкою через Нову пошту або Укрпошту?'
  },
  question2: {
    id: 'T7DXdV',
    defaultMessage: 'Як знайти препарат на сайті?'
  },
  question3: {
    id: 'Ow2uxS',
    defaultMessage: 'Чи можна замовити частину упаковки?'
  },
  question4: {
    id: '5Byrrb',
    defaultMessage: 'Чи оформлене моє замовлення?'
  },
  question5: {
    id: 'FbbBpX',
    defaultMessage: 'Не можу оформити замовлення. Що робити?'
  },
  question6: {
    id: 'kwl5PH',
    defaultMessage: 'Як зробити замовлення?'
  },
  question7: {
    id: 'BaKw5F',
    defaultMessage: 'Як мені вибрати конкретну аптеку?'
  },
  question8: {
    id: 'MCyDG8',
    defaultMessage:
      'Я можу зробити замовлення з самовивозом з аптеки і оплатити його карткою на сайті?'
  },
  question9: {
    id: 'R3zanR',
    defaultMessage:
      'Скільки діє бронь сформованого замовлення за допомогою Електронної інформаційної системи?'
  },
  question10: {
    id: 'D4AobN',
    defaultMessage: 'Чи всі товари, розміщені на сайті компанії, є у наявності?'
  },
  answer1: {
    id: 'CAik9k',
    defaultMessage:
      'На жаль доставка ще не реалізована, доступно отримання при самовивозі з аптеки'
  },
  answer2: {
    id: 'UU4tA5',
    defaultMessage:
      'Скористайтесь пошуком та введіть назву препарату. Потім оберіть потрібну форму випуску та дозування'
  },
  answer3: {
    id: 'lQuZBh',
    defaultMessage:
      'Так, ви можете замовити частину упаковки. Для цього додайте необхідні товари в список і перейдіть на сторінку оформлення замовлення. При оформленні замовлення ви можете вказати необхідну кількість товарів, в тому числі і необхідну частину упаковки.'
  },
  answer4: {
    id: '0bub3Z',
    defaultMessage:
      "Якщо замовлення було оформлене правильно, то вам прийде SMS з номером замовлення. Якщо ви не отримали SMS повідомлення або повідомлення в Viber протягом 10 хвилин, зв'яжіться, будь ласка, з нашою службою підтримки."
  },
  answer5: {
    id: 'bX1W/K',
    defaultMessage:
      "Зверніться, будь ласка, в службу підтримки, ми обов'язково вам допоможемо. Ви можете зв'язатися з нами за допомогою онлайн чату на сайті, Telegram або за телефоном 0800 333 132."
  },
  answer6: {
    id: 'Iva1Bu',
    defaultMessage:
      '1) Скористайтеся пошуком, щоб знайти товари, які вас цікавлять. 2) Додайте товари в список. 3) Перейдіть до оформлення замовлення і виберіть зручну аптеку.'
  },
  answer7: {
    id: 'Sl6W2u',
    defaultMessage:
      'Ви можете вибрати аптеку на сторінці оформлення замовлення, за умови, що товари з вашого замовлення є в наявності в цій аптеці. Деяких аптек немає в списку доступних, так як вони ще не підключилися до нас'
  },
  answer8: {
    id: 'Npgs1+',
    defaultMessage:
      'Замовлення з самовивозом з аптеки оплачуються безпосередньо в аптеці. При отриманні товару ви можете вибрати оплату карткою або готівкою.'
  },
  answer9: {
    id: 'qgAj9d',
    defaultMessage: 'Бронь діє 3 дні згідно з робочим часом аптек'
  },
  answer10: {
    id: '8zNfVN',
    defaultMessage:
      'Інформація про наявність та доступність до замовлення товарів відображається у картці товару.'
  },
  homeBreadCrumb: {
    id: '/YV5ee',
    defaultMessage: 'Головна'
  },
  answers: {
    id: 'sEE4i9',
    defaultMessage: 'Відповіді на поширені питання'
  }
});

export default trns;
